import BrevetLevelAsItem from "../../items/brevetScreen/BrevetLevelAsItem";
import {kBrevetExams} from "../../../constants/exams";
import BrevetExamItem from "../../items/brevetScreen/BrevetExamItem";

export default function BrevetExamsList() {
    // Used in BrevetCoreContent to display list of displayed
    // brevet LevelAs

    // PROPERTIES
    return (
        <div className="w-full mt-[32px] flex flex-wrap gap-[16px]">
            {kBrevetExams?.map((exam, index) => (
                <BrevetExamItem key={index}
                                   index={index}
                                   exam={exam} />
            ))}
        </div>
    );
}